import React from 'react';
import {Button} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  children?: React.ReactNode,
};

const BaseLink = ({children, ...props}: Props) => (
  <Button {...props} as={Link}>
    {children}
  </Button>
);

const StyledBaseLink = styled(BaseLink)`
  &&& {
    border-radius: 20px;
    border: solid 1px #ef5350;
    background-color: #fff;

    height: ${props => props.size === 'large' && '56px'};
    padding: ${props => props.size === 'large' && '0 30px'};
    border-radius: ${props => props.size === 'large' && '28px'};
  }
`;

const BasicLink = styled(StyledBaseLink)`
  &&& {
    color: #ef5350 !important;

    &:hover {
      color: #ef5350 !important;
      background-color: #f9f0f0 !important;
    }
  }
`;

const PositiveLink = styled(StyledBaseLink)`
  &&& {
    background-color: #ef5350;
    color: white !important;

    &:hover {
      background-color: #f16c6a;
    }
  }
`;

export {BasicLink, PositiveLink};
